import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { postFormsOtp } from '../requests';
import { PostFormsOtpRequestType } from '../types';

const removeEmptyValues = <T = Record<string, unknown>>(obj: T): T =>
  Object.fromEntries(
    Object.entries(obj as any).filter(([_, value]) => value !== undefined),
  ) as T;

export const useExtFormsOtp = (
  form: PostFormsOtpRequestType['pathParams']['form'],
) => {
  const { i18n } = useTranslation();

  return useMutation({
    mutationFn: (body: PostFormsOtpRequestType['body']) =>
      postFormsOtp({
        pathParams: { form },
        body: removeEmptyValues(body),
        headers: {
          'x-app-locale': i18n.language,
        },
      }),
  });
};
